import { AiFillAppstore } from "react-icons/ai";
import { FaBrain } from "react-icons/fa";
import { SiProgress } from "react-icons/si";
import { CgWebsite } from "react-icons/cg";
import { MdAnalytics } from "react-icons/md";

// Features Data
export const featuresData = [
  {
    id: 1,
    title: "Project Management",
    des: "Want to gain real-life experience of managing a complete software project cycle.",
  },
  {
    id: 2,
    icon: <AiFillAppstore />,
    title: "App Development",
    des: "Will learn this soon in near future !",
  },
  {
    id: 3,
    icon: <SiProgress />,
    title: "SEO Optimisation",
    des: "Will learn this soon in near future !",
  },
  {
    id: 4,
    icon: <CgWebsite />,
    title: "Web Development",
    des: "Have completed a MERN stack development course from Udemy. Have developed various projects and hosted them too, check them on my github.",
  },
  {
    id: 5,
    icon: <MdAnalytics />,
    title: "Data Analyst",
    des: "Learned data extraction,cleaning, pattern identification & web scrapping skills during my internship. ALso, trained the ML models.",
  },
  {
    id: 6,
    icon: <FaBrain />,
    title: "Machine Learning",
    des: "Have completed a ML course from Acmegrade(Partner Mood Indigo IITB). Have developed some projects, check them on my github.",
  },
];
